export const injectStyles = (css) => {
    const styles = document.createElement('style');
    styles.appendChild(document.createTextNode(css));
    document.head.appendChild(styles);
};
const forceViewSourceForEditButtons = () => {
    const lockIcon = `<svg class="wds-icon wds-icon-small"><svg id="wds-icons-lock-small" viewBox="0 0 18 18"><path id="lock-small" d="M14 16H4V8h10v8zM7 4c0-1.104.897-2 2-2s2 .896 2 2v2H7V4zm8 2h-2V4c0-2.205-1.794-4-4-4S5 1.795 5 4v2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-5 4H8a1 1 0 1 0 0 2v1a1 1 0 1 0 2 0v-1a1 1 0 1 0 0-2"></path></svg></svg>`;
    const url = new URL(window.location.href);
    url.searchParams.set('action', 'edit');
    const viewSourceHref = url.href;
    const editA = document.getElementById('log-in-edit');
    editA.setAttribute('href', viewSourceHref);
    editA.innerHTML = `${lockIcon} View Source`;
    const sideEdit = document.getElementById('log-in-edit-side-tool');
    sideEdit.setAttribute('href', viewSourceHref);
    sideEdit.innerHTML = lockIcon;
    sideEdit.setAttribute('data-wds-tooltip', 'View Source');
};
/*
    Variant A:
    - Change the text of the edit button to "Edit" instead of "Sign in to edit"
 */
export const renderVariantA = () => {
    const editA = document.getElementById('log-in-edit');
    editA.innerHTML = editA.innerHTML.replace('Sign in to edit', 'Edit');
    Array.from(document.querySelectorAll([2, 3, 4, 5, 6].map((headerValue) => `h${headerValue} .mw-editsection a`).join(', '))).forEach((node) => {
        node.setAttribute('title', '');
    });
};
/*
    Variant B:
    - Change edit and side edit buttons to "View source" with lock icon
    - Add custom tooltip for pen icons next to paragraphs
 */
export const renderVariantB = () => {
    forceViewSourceForEditButtons();
    Array.from(document.querySelectorAll([2, 3, 4, 5, 6].map((headerValue) => `h${headerValue} .mw-editsection a`).join(', '))).forEach((node) => {
        node.setAttribute('title', '');
    });
    injectStyles(`
		.mw-editsection a:after {
		    content: 'Sign in to edit';
		    position: absolute;
		    display: none;
		    font-size: 12px;
		    line-height: 1.25;
		    left: 100%;
		    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.3);
		    border: solid 1px var(--theme-borer-color);
		    background-color: var(--theme-page-background-color--secondary);
		    padding: 6px 9px;
		    color: var(--theme-page-text-color);
		    font-weight: normal;
		    border-radius: 3px;
		    margin-left: 12px;
		    top: 50%;
		    transform: translateY(-50%);
		}
		
		.mw-editsection a:hover:after {
		    display: block;
		}
		
		.mw-editsection a:hover:before {
		    display: block;
		}
		
		.mw-editsection a {
		    position: relative;
		    display: inline-block;
		}
		
		
		.mw-editsection a:before {
		    content: '';
		    right: 0;
		    transform: translateX(14px) translateY(-50%);
		    top: 50%;
		    width: 0;
		    height: 0;
		    border-top: 10px solid transparent;
		    border-bottom: 10px solid transparent;
		
		    border-right: 10px solid var(--theme-page-background-color--secondary);
		    position: absolute;
		    z-index: 2;
		    display: none;
		}
		
		
		h3 .mw-editsection a:after,
		h4 .mw-editsection a:after,
		h5 .mw-editsection a:after {
		    left: 50%;
		    top: 100%;
		    transform: translateX(-50%);
		    margin-left: 0;
		    margin-top: 12px;
		}
		
		h3 .mw-editsection a:before,
		h4 .mw-editsection a:before,
		h5 .mw-editsection a:before {
		    left: 50%;
		    top: 100%;
		    border-left: 10px solid transparent;
		    border-right: 10px solid transparent;
		    border-bottom: 10px solid var(--theme-page-background-color--secondary);
		    border-top: none;
		    transform: translateX(-50%) translateY(4px);
		}
	`);
};
/*
    Variant C:
    - Change edit and side edit buttons to "View source" with lock icon
    - Add label "Edit" to pen icons next to paragraphs
 */
export const renderVariantC = () => {
    Array.from(document.querySelectorAll([2, 3, 4, 5, 6].map((headerValue) => `h${headerValue} .mw-editsection a`).join(', '))).forEach((node) => {
        const span = Object.assign(document.createElement('span'), {
            innerHTML: 'Edit',
            className: 'editsection-header-label',
        });
        node.appendChild(span);
        node.setAttribute('title', '');
    });
    injectStyles(`
        .editsection-header-label {
            font-size: 14px;
            line-height: 1.25;
            padding-left: 6px;
        }
        
        .mw-editsection a:hover, .mw-editsection a:active, .mw-editsection a:focus {
            text-decoration: none !important;
        }
    `);
    forceViewSourceForEditButtons();
};
/*
    Variant D:
    - Display pen icons only next to H2 paragraphs
 */
export const renderVariantD = () => {
    Array.from(document.querySelectorAll('h2 .mw-editsection .wds-icon')).forEach((node) => (node.innerHTML = `<use xlink:href="#wds-icons-pencil-small"/>`));
    injectStyles(`
        #content h2 .mw-editsection {
            float: left;
            margin-right: 9px;
            margin-left: 0;
            
        }
        
        #content h2 .mw-editsection .wds-icon {
            height: 18px;
            width: 18px;
        }
        
        #content h3 .mw-editsection, 
        #content h4 .mw-editsection, 
        #content h5 .mw-editsection, 
        #content h6 .mw-editsection {
            display: none;
        }
    `);
};
